import { API_BASE_URL } from '../../utils/apiClient';

export const userSignIn = async (payload) => {
  const res = await fetch(`${API_BASE_URL}/api/users/UserSignIn`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.error || `Login failed (${res.status})`);
  }

  return await res.json();
};
